export const ACTION_PLAN_REQUEST = "ACTION_PLAN_REQUEST";
export const ACTION_PLAN_RECEIVE = "ACTION_PLAN_RECEIVE";
export const ACTION_PLAN_FAILURE = "ACTION_PLAN_FAILURE";
export const RESET_ACTION_PLAN = "RESET_ACTION_PLAN";

// common problem action plan 
export const COMMON_ACTION_PLAN_REQUEST = "COMMON_ACTION_PLAN_REQUEST";
export const COMMON_ACTION_PLAN_RECEIVE = "COMMON_ACTION_PLAN_RECEIVE";
export const COMMON_ACTION_PLAN_FAILURE = "COMMON_ACTION_PLAN_FAILURE";
export const RESET_COMMON_ACTION_PLAN = "RESET_COMMON_ACTION_PLAN";